import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// CDK
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';

// RxJs
import { Observable, take } from 'rxjs';

// NgRX
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/reducers';
import { selectSessionUserState } from '@core/store/selectors/session.selectors';



@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,
    CdkMenu,
    CdkMenuItem,
    CdkMenuTrigger,
    MatIconModule,
  ],
  selector: 'rental-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavSComponent implements OnInit {

  public user$?: Observable<any>;


  constructor(
    private readonly store: Store<AppState>
  ) { }


  ngOnInit(): void {
    this.user$ = this.store.select(selectSessionUserState).pipe(take(2));
  }
}
